import { render, staticRenderFns } from "./CreateBiAcces.vue?vue&type=template&id=2e97d732&"
import script from "./CreateBiAcces.vue?vue&type=script&lang=ts&"
export * from "./CreateBiAcces.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBiAcces.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports